//apifetch
import axios from 'axios';

//translate
import i18n from '../translate/i18n';

import { requestNotificationPermission } from '../firebase/notifgicationFireBase';

//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;


export const GetLogoutApi = async () => {
    const token = localStorage.getItem("token")
    const deviceToken = await requestNotificationPermission().then((token) => token);
    try {
        const response = await axios.get(`${baseURL}/auth/logout`,{
            params: {
                device_token: deviceToken || "",
            },
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': i18n.language,
                Authorization: `Bearer ${token}`
            },
        });
        return response.data;
    } catch (error: any) {
        console.error(error.response?.data || error.message);
        throw error;
    }
};